export const resources = {
  resourcesFolderInfoText: '파일(들)',
  resourcesItemInfoLastUpdText: '최근 업데이트',
  resourcesItemInfoUploadedText: '업로드됨',
  resourcesSearchInputText: '검색',
  resourcesUserActionSheetOptionTitle: '링크 복사',
  resourcesActionCopiedAlertText: '링크가 복사되었습니다!',
  resourcesOwnersCurtainEditOptionText: '제목 편집',
  resourcesOwnersCurtainDeleteOptionText: '삭제',
  resourcesOwnerCurtainHideOptionText: '숨기기 (비활성)',
  resourcesEditPopupTitle: '제목 편집',
  resourcesEditPopupResetButtonTitle: '초기화',
  resourcesEditPopupApplyButtonTitle: '적용',
  resourcesItemEditedAlertText: '항목이 성공적으로 업데이트되었습니다!',
  resourcesHidePopupTitle: '숨기기',
  resourcesHidePopupText: '이 항목을 숨기시겠습니까?',
  resourcesHidePopupCancelButtonTitle: '취소',
  resourcesHidePopupConfirmButtonTitle: '확인',
  resourcesDeletePopupTitle: '삭제',
  resourcesDeletePopupText: '이 항목을 삭제하시겠습니까?',
  resourcesDeletePopupCancelButtonTitle: '취소',
  resourcesDeletePopupConfirmButtonTitle: '확인',
  resourcesItemDeletedAlertText: '항목이 성공적으로 삭제되었습니다!',
  resourceDetailsLinkText: '이것은 외부 URL이며 새 창에서 열립니다. 열까요?',
  resourceDetailsLinkOpenButtonTitle: '열기',
  resourceDetailsLinkOpenAgainButtonTitle: '다시 열기',
  resourceDetailsLinkCopyURLButtonTitle: '대상 URL 복사',
  resourceDetailsLinkCopiedURLAlertText: 'URL이 복사되었습니다!',
  resurceDetailsLinkCurtainOptionCopyText: '링크 복사',
  resourceDetailsFileInfoLastUpdText: '최근 업데이트',
  resourceDetailsFileInfoUploadText: '업로드됨',
  resourceDetailsFileSaveButtonTitle: '열기',
  resourceDetailsFileCopyButtonTitle: '링크 복사',
  resourcesOwnersCurtainCopyOptionText: '링크 복사',
  resourceDetailsFileLoadingText: '다운로드 중...',
  resourceDetailsImageCurtainCopyOptionText: '링크 복사',
  resourceDetailsImageCurtainDownloadOptionText: '다운로드',
  resourceFolder: '폴더',
  resourceAdded: '추가됨'
}
